<template>
  <div>
    <h1>Booked Appointments</h1>
    <v-row v-if="bookedSlots">
      <v-data-table
        :headers="headers"
        single-expand
        :items="bookedSlots"
        class="elevation-1"
        :expanded.sync="expanded"
        show-expand
        :item-key="bookedSlots.name"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Booked for {{ currentDay.date }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="text-left">{{ item.bookingData.details }}</td>
        </template>
      </v-data-table>
    </v-row>
  </div>
</template>
<script>
import UtilsMixin from "../mixins/UtilsMixin";

export default {
  mixins: [UtilsMixin],
  data: () => ({
    expanded: [],
    bookedSlots: [],
    headers: [
      { text: "Time Booked", value: "starts_at" },
      { text: "Full Name", value: "bookingData.name" },
      { text: "Email", value: "bookingData.contactEmail" },
      { text: "Chat Preference", value: "bookingData.chatPreference" },
      { text: "Service", value: "bookingData.service" },
    ],
  }),
  props: {
    currentDay: {
      type: Object,
      default: () => {},
    },
  },
  created() {
    this.bookedSlots = this.currentDay.slots.filter(
      (slot) => slot.booked === true
    );
  },
};
</script>
